import React, { useEffect, useState } from 'react';
import PersonIcon from '@material-ui/icons/Person';
import OpenFlowModal from '../modal';
import DropDownPicker from '../../../../../components/picker/DropDownPicker';
import STRINGS from '../../../redux/strings';
import {
  CardWrapper,
  TlyfeSelector,
  LineSeperator,
  Heading,
  SubHeading,
  TlyfeButtonWrapper,
  FormContainer,
  RowContainer,
} from './../../screens/style';
import Tooltip from '@material-ui/core/Tooltip';
import { CardBox } from './../card';
import variables from '../variables.json';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Button } from '../button';
import { View } from 'react-native';
import { TextInput } from '../textinput';
import Text from '../../../../../components/text';
import getPlatformType from '../../../../../helpers/helpers';
import { showErrorToast } from '../../helpers';
function ContactCard(props) {
  const {
    name,
    is_lead,
    isLeadEditable,
    row,
    data,
    heading,
    nonRemove,
    onViewClick,
    selection,
    isSelected,
    onSelect,
    selectedEmailForLead,
    tooltip,
    iconColor,
    compactRow = false,
  } = props;
  const [teanantsData, setTeanantData] = React.useState(data);
  const [showModal, setShowModal] = React.useState(false);
  const [showMakeHeadModal, setShowMakeHeadModal] = React.useState(false);
  const [showDeleteCardModal, setShowDeleteCardModal] = React.useState(false);
  const [editTeanantID, setEditTeanantID] = React.useState('');
  console.log(' teanantsData={ true}', teanantsData);
  const [complete, setComplete] = useState(isSelected);
  const type = heading == 'Landlord Details' ? 'landlord' : heading == 'Guarantor Details' ? 'guarantor' : 'tenant';
  const displayName =
    name ||
    `${teanantsData?.title || ''} ${teanantsData?.first_name || ''} ${teanantsData?.last_name || ''}`
      .replace(/\s+/g, ' ')
      .trim() ||
    'Landlord';

  useEffect(() => {
    setComplete(isSelected);
  }, [isSelected]);

  useEffect(() => {
    setTeanantData(data);
  }, [data]);

  const handleChange = (event) => {
    setComplete(!complete);
    onSelect(!complete);
  };
  const renderRemoveCardBody = () => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <Text>Do you wish to remove this ?</Text>
      <TlyfeButtonWrapper style={{marginBottom: '5%'}}>
        <Button
          onClick={() => {
            props.onDelete();
            setShowDeleteCardModal(false);
          }}
          title={'Yes'}
          type="stripe"
          style={{ borderColor: '#90C418', color: '#90C418' }}
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setShowDeleteCardModal(false);
          }}
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>

      <RowContainer>
        <Text>Please Note</Text>
        <Text> Once you remove this you cannot undo this change</Text>
      </RowContainer>
    </View>
  );
  const renderArchiveCardBody = () => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <Text bold fontSize={16} marginBottom={3}>Please Note:</Text>
      <Text fontSize={14}>You must click "save and continue" for this change to take affect. Once you make this change you cannot undo it. </Text>
      <TlyfeButtonWrapper style={{marginTop: '5%'}}>
        <Button
          onClick={() => {
            props.onDelete();
            setShowDeleteCardModal(false);
          }}
          title={'Yes'}
          type="stripe"
          style={{ borderColor: '#90C418', color: '#90C418' }}
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setShowDeleteCardModal(false);
          }}
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
     
    </View>
  );
  const renderMakeLeadModalBody = () => (
    <View
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      }}
    >
      <Text>
        Do you wish to make this {type} as Lead {type}
      </Text>
      <TlyfeButtonWrapper style={{marginTop:20}}>
        <Button
          onClick={() => {
            props.onMakeLead();
            setShowMakeHeadModal(false);
            // setConfirm(true)
          }}
          style={{ borderColor: '#90C418', color: '#90C418' }}
          title={'Yes'}
          type="stripe"
        />
        &nbsp;&nbsp;
        <Button
          onClick={() => {
            setShowMakeHeadModal(false);
          }}
          style={{ borderColor: '#FC4850', color: '#FC4850' }}
          title={'No'}
          type="stripe"
        />
      </TlyfeButtonWrapper>
      <RowContainer>
        <Text>Please Note</Text>
        <Text>
          If you make tenent the Lead {type} any other {type} has been assigned as lead {type} would no longer be the
          Lead {type}
        </Text>
      </RowContainer>
    </View>
  );
const layoutType = getPlatformType()
  const renderModalBody = () => (
    <View
      style={
        layoutType === 'web'
          ? {
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'space-between',
              width: '100%',
            }
          : {
              flexDirection: 'column',
              width: '100%',
            }
      }
    >
      {teanantsData?.opbrix_id && (
        <TextInput
          disabled={true}
          title={<Text bold>tlyfe ID:</Text>}
          type={'row'}
          wrapperstyle={{
            width: '99%',
            marginTop: 20,
          }}
          containerstyles={{ width: '100%' }}
          value={teanantsData?.opbrix_id || ''}
        />
      )}
      <View style={{ width: layoutType === 'web' ? '18%' : '100%', marginTop: 20 }}>
        <p style={{ fontFamily: 'lato' }}>
          <Text bold>Title:</Text>
        </p>
        <DropDownPicker
          disabled={editTeanantID ? false : true}
          items={STRINGS.OPENFLOW_TITLES.map((ITEM) => ({ value: ITEM, label: ITEM }))}
          defaultValue={teanantsData.title}
          onChangeItem={(e) => setTeanantData({ ...teanantsData, title: e.value })}
        />
      </View>
      <TextInput
        disabled={editTeanantID ? false : true}
        title={<Text bold>First Name:</Text>}
        type={'row'}
        wrapperstyle={{
          width: layoutType == 'web' ? '30%' : '100%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.first_name || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, first_name: event.target.value });
        }}
      />
      <TextInput
    disabled={editTeanantID? false : true}
        title={<Text bold>Last Name:</Text>}
        type={'row'}
        wrapperstyle={{
          width:layoutType=="web"? '49%':"100%",  
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.last_name || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, last_name: event.target.value });
        }}
      />
      <TextInput
    disabled={editTeanantID? false : true}
        title={<Text bold>Email:</Text>}
        type={'row'}
        wrapperstyle={{
          width:layoutType=="web"? '49%':"100%",  
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.email || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, email: event.target.value });
        }}
      />
      <TextInput
    disabled={editTeanantID? false : true}
        title={<Text bold>Contact Number:</Text>}
        type={'row'}
        wrapperstyle={{
          width:layoutType=="web"? '49%':"100%",  
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.number || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, number: event.target.value.replace(/\D/, '') });
        }}
      />
      <TextInput
        disabled={editTeanantID? false : true}
        title={<Text bold>Landlord Registration Number:</Text>}
        type={'row'}
        wrapperstyle={{
          width: layoutType === 'web' ? '49%' : '100%',
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.license_number || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, license_number: event.target.value });
        }}
      />
      <TextInput
               disabled={editTeanantID? false : true}
        title={<Text bold>Post Code:</Text>}
        type={'row'}
        wrapperstyle={{
          width:layoutType=="web"? '49%':"100%",  
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.post_code || ''}
        onChange={(event) => {
          setTeanantData({ ...teanantsData, post_code: event.target.value });
        }}
      />
      <TextInput
        disabled={editTeanantID? false : true}
        title={<Text bold>Address:</Text>}
        type={'row'}
        wrapperstyle={{
          width:layoutType=="web"? '49%':"100%",  
          marginTop: 20,
        }}
        containerstyles={{ width: '100%' }}
        value={teanantsData.correspondece_address ?? teanantsData.address ?? ''}
        onChange={(event) => {
          setTeanantData({
            ...teanantsData,
            address: event.target.value,
            correspondece_address: event.target.value ? event.target.value : null,
          });
        }}
      />

      <Button
        style={{ marginTop: 20, marginBottom: 10, borderColor: '#90C418' }}
        onClick={() => {
          if (editTeanantID === teanantsData?.tenant_id) {
          if (!teanantsData.number) {
            showErrorToast("Contact number is required")
          } else if (teanantsData?.number?.length <= 7) {
            showErrorToast("Contact number must be more than 7 digits")
          }else{
            props?.onEdit(teanantsData);
            setEditTeanantID(null);
            setShowModal(false)
          }
           
          } else {
            setEditTeanantID(teanantsData?.tenant_id);
          }
        }}
        title={editTeanantID === teanantsData?.tenant_id ? 'Save Landlord' : 'Edit Landlord'}
        type="stripe"
      />
    </View>
  );
  return (
    compactRow ? (
      <CardBox
        hasBorderRadius
        hasShadow
        style={{
          padding: 16,
          marginRight: 0,
          marginBottom: 0,
          width: layoutType === 'phone' ? '100%' : 251,
          maxWidth: layoutType === 'phone' ? '100%' : 251,
          minWidth: layoutType === 'phone' ? '100%' : 251,
          height: layoutType === 'phone' ? 'auto' : 188,
          alignSelf: 'flex-start',
          minHeight: 'auto',
          border: '1px solid #E4EAF5',
          backgroundColor: '#FFFFFF',
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            gap: 10,
            width: '100%',
            height: 'auto',
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              gap: 10,
              flex: 1,
            }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: is_lead ? 'rgba(144, 196, 24, 0.12)' : 'rgba(159, 120, 255, 0.12)',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 0,
              }}
            >
              <PersonIcon
                style={{
                  height: 20,
                  width: 20,
                  color: is_lead ? variables.lead_green : variables.heliotrope,
                }}
              />
            </View>

            <View style={{ flex: 1, minWidth: 0 }}>
              <View style={{ flexDirection: 'column', gap: 1 }}>
                <Text fontSize={15} bold color={variables.black}>
                  {displayName}
                </Text>
                <Text fontSize={12} color={variables.darkgrey}>
                  {teanantsData?.email || teanantsData?.opbrix_id || 'Landlord profile'}
                </Text>
                {teanantsData?.number ? (
                  <Text fontSize={12} color={variables.darkgrey}>
                    Contact: {teanantsData.number}
                  </Text>
                ) : null}
              </View>

              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 10,
                  flexWrap: 'wrap',
                  marginTop: 10,
                }}
              >
                <Text
                  onPress={() => {
                    if (onViewClick) {
                      onViewClick();
                    } else setShowModal(true);
                  }}
                  style={{
                    color: variables.heliotrope,
                    fontSize: 12,
                    cursor: 'pointer',
                    fontWeight: 500,
                    fontFamily: 'lato',
                  }}
                >
                  View
                </Text>
                {!is_lead && isLeadEditable && (
                  <Text
                  onPress={() => {
                      setShowMakeHeadModal(true);
                      selectedEmailForLead(row);
                    }}
                    style={{
                      color: variables.lead_green,
                      fontSize: 12,
                      cursor: 'pointer',
                      fontWeight: 500,
                      fontFamily: 'lato',
                    }}
                  >
                    Make Lead
                  </Text>
                )}
                {nonRemove ? null : (
                  <Text
                    onPress={() => {
                      setShowDeleteCardModal(true);
                    }}
                    style={{
                      color: variables.tint,
                      fontSize: 12,
                      cursor: 'pointer',
                      fontWeight: 500,
                      fontFamily: 'lato',
                    }}
                  >
                    Remove
                  </Text>
                )}
              </View>
            </View>
          </View>
        </View>

        {showModal && (
          <OpenFlowModal
            showModal={showModal}
            setShowModal={setShowModal}
            modalBody={renderModalBody()}
            showFooter={false}
            modalHeading={props?.heading ? props.heading : 'Tenant Details'}
            modalWidth={600}
          />
        )}
        {showMakeHeadModal && (
          <OpenFlowModal
            showModal={showMakeHeadModal}
            setShowModal={setShowMakeHeadModal}
            modalBody={renderMakeLeadModalBody()}
            showFooter={false}
            modalHeading="Make Lead ?"
            modalWidth={600}
          />
        )}
        {showDeleteCardModal && (
          <OpenFlowModal
            showModal={showDeleteCardModal}
            setShowModal={setShowDeleteCardModal}
            modalBody={props.isArchive ? renderArchiveCardBody() : renderRemoveCardBody()}
            showFooter={false}
            modalHeading={props.isArchive ? 'Archive ?' : 'Remove ?'}
            modalWidth={600}
          />
        )}
      </CardBox>
    ) : (
    <CardBox
      hasBorderRadius
      hasShadow
      style={{
        padding: 16,
        marginRight: 0,
        marginBottom: 0,
        width: layoutType === 'phone' ? '100%' : 251,
        maxWidth: layoutType === 'phone' ? '100%' : 251,
        minWidth: layoutType === 'phone' ? '100%' : 251,
        height: layoutType === 'phone' ? 'auto' : 188,
        alignSelf: 'flex-start',
        minHeight: 'auto',
        border: '1px solid #E4EAF5',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
      }}
    >
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          gap: 10,
          alignItems: 'flex-start',
        }}
      >
        <View
          style={{
            width: 44,
            minWidth: 44,
            alignItems: 'center',
          }}
        >
          <Tooltip
            title={` ${tooltip ? tooltip : is_lead ? 'Lead ' + type : 'Not Lead ' + type}`}
            placement="top-start"
          >
            <PersonIcon
              style={{
                height: is_lead ? 36 : 32,
                width: is_lead ? 36 : 32,
                color: iconColor ? iconColor : is_lead ? variables.lead_green : variables.heliotrope,
              }}
            />
          </Tooltip>
          <Text
            onPress={() => {
              if (onViewClick) {
                onViewClick();
              } else setShowModal(true);
            }}
            style={{
              color: variables.heliotrope,
              fontSize: 13,
              marginTop: 8,
              fontWeight: 500,
              fontFamily: 'lato',
              textAlign: 'center',
            }}
          >
            View
          </Text>
          {!is_lead && isLeadEditable && (
            <Text
              onPress={() => {
                setShowMakeHeadModal(true);
                selectedEmailForLead(row);
              }}
              style={{
                marginTop: 8,
                color: variables.lead_green,
                fontSize: 13,
                fontFamily: 'lato',
                textAlign: 'center',
              }}
            >
              Make Lead
            </Text>
          )}
        </View>

        <View
          style={{
            flex: 1,
            minWidth: 0,
            flexDirection: 'column',
            gap: 4,
          }}
        >
          <Text style={{ fontSize: 15, lineHeight: 18, fontWeight: '700', color: variables.black }}>
            {displayName}
          </Text>
          <Text fontSize={12} color={variables.darkgrey}>
            {teanantsData?.email || teanantsData?.opbrix_id || 'Landlord profile'}
          </Text>

          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              gap: 10,
              flexWrap: 'wrap',
              marginTop: 6,
            }}
          >
            {nonRemove ? null : (
              <Text
                onPress={() => {
                  setShowDeleteCardModal(true);
                }}
                style={{
                  color: variables.tint,
                  fontSize: 12,
                  fontFamily: 'lato',
                  fontWeight: 500,
                }}
              >
                Remove
              </Text>
            )}
            {selection && (
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ color: variables.heliotrope }}
                    checked={complete}
                    onChange={handleChange}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<RadioButtonCheckedIcon />}
                    name="checkedH"
                  />
                }
              />
            )}
          </View>
        </View>
      </View>
      {showModal && (
        <OpenFlowModal
          showModal={showModal}
          setShowModal={setShowModal}
          modalBody={renderModalBody()}
          showFooter={false}
          modalHeading={props?.heading ? props.heading : 'Tenant Details'}
          modalWidth={600}
        />
      )}
      {showMakeHeadModal && (
        <OpenFlowModal
          showModal={showMakeHeadModal}
          setShowModal={setShowMakeHeadModal}
          modalBody={renderMakeLeadModalBody()}
          showFooter={false}
          modalHeading="Make Lead ?"
          modalWidth={600}
        />
      )}
      {showDeleteCardModal && (
        <OpenFlowModal
          showModal={showDeleteCardModal}
          setShowModal={setShowDeleteCardModal}
          modalBody={props.isArchive?renderArchiveCardBody(): renderRemoveCardBody()}
          showFooter={false}
          modalHeading={props.isArchive?"Archive ?":"Remove ?"}
          modalWidth={600}
        />
      )}
    </CardBox>
    )
  );
}
export default ContactCard;
